const LeaveDetailsGrid = ({
  employeeData,
  managerLabel,
  managerValue,
}) => {
  return (
    <div className="grid grid-cols-5 gap-4 rounded-xl border border-gray-100 bg-[#f9fafe] px-5 py-4">
      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
          Leave Start Date
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-800">
          {employeeData?.leave_from}
        </p>
      </div>

      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
          Leave End Date
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-800">
          {employeeData?.leave_to}
        </p>
      </div>

      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
          Leave Type
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-800">
          {employeeData?.leave_type}
        </p>
      </div>

      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
          No. of Days
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-800">
          {employeeData?.days_count}
        </p>
      </div>

      <div>
        <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
          {managerLabel}
        </p>
        <p className="mt-1 text-sm font-semibold text-gray-800">
          {managerValue}
        </p>
      </div>
    </div>
  );
};

export default LeaveDetailsGrid;